import { IslandComponent } from '@island-runtime/types';

/**
 * `data-react-island="AnnualPlanPopup"` — renders nothing. The host includes it
 * from `popups_list.html.twig` (edusson `react_annual_plan_popup.html.twig`) on
 * pages without the SPA, so that the island root
 * (`island-runtime/IslandRoot.tsx`, which renders `Popups`) exists there for a
 * `?modal=upgrade_annual` link (`usePopupAutoOpen`). It matters on a page with
 * no other island (the front layout): the profile pages have the
 * `ProfileHeader` island, whose upgrade button opens the popup itself.
 *
 * It takes no `data-props`.
 */
const AnnualPlanPopupIsland: IslandComponent = () => null;

export default AnnualPlanPopupIsland;
